module.exports = __webpack_public_path__ + "static/img/cinema-18.531fddc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/png-img/cinema-18.png
// module id = 1207
// module chunks = 173